import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7456b682"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "setting-error"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pulse_loader" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pls p1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "pls p2" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "loader",
    style: _normalizeStyle([_ctx.isShow ? _ctx.showup : ''])
  }, [
    (_ctx.data.status == 404)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.data.status), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.data.message), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_2
  ], 4))
}